
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"aria-hidden":"true","viewBox":"0 0 45 45","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5 5h9v9H5V5zm14 0h9v9h-9V5zm13 0h9v9h-9V5zM5 18h9v9H5v-9zm14 0h9v9h-9v-9zm13 0h9v9h-9v-9zM5 31h9v9H5v-9zm14 0h9v9h-9v-9zm13 0h9v9h-9v-9z"}})])
          )
        }
      }
    